module.exports = __webpack_public_path__ + "static/media/medalQuestion.0cc95d55.png";